<div class="rounded-xl fixed-height flex justify-start items-center md:block mt-2 p-6 bg-grey-50 shadow-dark">

  <app-avatar-circle *ngIf="icon" [type]="'icon'" [data]="icon" size="m" [style]="style" class="mr-6"></app-avatar-circle>

  <div>
    <div *ngIf="title" class="mt-4 title-t2">{{title}}</div>
    <div *ngIf="description" class="mt-4 body-b2">{{description}}</div>
  </div>
</div>
